import { CorrectFtbAnswersFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuestionPerformance';
import { QuizPlayerFtbComponentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerQuestionContent';
import { FtbResponse } from '@/types/schema';

import { OptionsListItemTypeEnum } from '../../single-select/types';
import { QuizField } from '../../types';

export const isValidFtbSubmission: QuizField['isValidSubmission'] = (question, submission) => {
  const blanksCount = question.ftbComponents.filter((component) => component.isBlank).length;
  return submission?.ftbResponse?.length === blanksCount;
};

interface Params {
  ftbComponent: QuizPlayerFtbComponentFragment;
  ftbResponse: FtbResponse[];
  correctFtbAnswers?: CorrectFtbAnswersFragment[];
}

export const getFtbResponseType = (params: Params) => {
  const { ftbResponse, ftbComponent, correctFtbAnswers } = params;
  const responseAnswer = ftbResponse.find((response) => response.blankId === ftbComponent?.id);

  const ftbIdToTextMap = getFtbIdToTextMap(correctFtbAnswers);

  if (!responseAnswer) {
    return OptionsListItemTypeEnum.Missed;
  }

  return responseAnswer.text === ftbIdToTextMap[ftbComponent.id]
    ? OptionsListItemTypeEnum.Correct
    : OptionsListItemTypeEnum.Incorrect;
};

export const getFtbIdToTextMap = (correctFtbAnswers?: CorrectFtbAnswersFragment[]) =>
  (correctFtbAnswers || []).reduce(
    (acc, answer) => {
      acc[answer.id] = answer.text || '';
      return acc;
    },
    {} as { [key: string]: string },
  );
